import { motion } from 'framer-motion';

const Sustainability = () => {
  const initiatives = [
    {
      title: 'Carbon-Neutral Fleet',
      description: 'Transitioning to electric and hybrid vehicles to reduce carbon emissions across our transportation network.',
      icon: '🌱'
    },
    {
      title: 'Eco-Friendly Packaging',
      description: 'Using biodegradable and recyclable packaging materials to minimize waste and environmental impact.',
      icon: '♻️'
    },
    {
      title: 'Renewable Energy',
      description: 'Powering our warehouses and offices with solar energy and other renewable sources.',
      icon: '☀️'
    },
    {
      title: 'Optimized Routes',
      description: 'Using AI to plan the most fuel-efficient routes, reducing unnecessary mileage and emissions.',
      icon: '🛣️'
    }
  ];

  return (
    <section className="py-16 bg-white dark:bg-secondary-800">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 text-secondary-900 dark:text-white">Our Commitment to Sustainability</h2>
          <p className="text-secondary-600 dark:text-secondary-300">
            At VEDUS, we believe that responsible logistics is not just good for the planet—it's good for business. We're committed to leading the industry in sustainable practices.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {initiatives.map((initiative, index) => (
            <motion.div 
              key={initiative.title}
              className="bg-secondary-50 dark:bg-secondary-700 p-6 rounded-lg shadow-md"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="text-4xl mb-4">{initiative.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-secondary-900 dark:text-white">
                {initiative.title}
              </h3>
              <p className="text-secondary-600 dark:text-secondary-300">
                {initiative.description}
              </p>
            </motion.div>
          ))}
        </div>
        
        <motion.div 
          className="bg-primary-600 text-white rounded-lg shadow-lg p-8"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="md:flex items-center">
            <div className="md:w-2/3 mb-6 md:mb-0 md:pr-8">
              <h3 className="text-2xl font-bold mb-4">Our Environmental Goals</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Reduce carbon emissions by 50% by 2030</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Achieve 100% renewable energy usage in all facilities by 2028</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Eliminate single-use plastics from our operations by 2025</span>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Plant 1 million trees through our reforestation partnerships</span>
                </li>
              </ul>
            </div>
            <div className="md:w-1/3">
              <div className="bg-white bg-opacity-10 p-6 rounded-lg">
                <div className="text-center">
                  <div className="text-4xl font-bold mb-2">30%</div>
                  <p className="text-sm opacity-80">Carbon reduction achieved so far</p>
                </div>
                <div className="h-2 bg-white bg-opacity-20 rounded-full mt-4">
                  <div className="h-2 bg-white rounded-full" style={{ width: '30%' }}></div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Sustainability;